import { motion } from "framer-motion";
import {
  Wheat,
  Drumstick,
  Pill,
  Sparkles,
  Droplets,
  Fuel,
  Layers,
  Activity,
} from "lucide-react";
import { INDUSTRIES } from "../../data/content";

const ICONS = [Wheat, Drumstick, Pill, Sparkles, Droplets, Fuel, Layers, Activity];

const fadeUp = {
  hidden: { opacity: 0, y: 18 },
  show: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, delay: i * 0.06, ease: [0.22, 1, 0.36, 1] },
  }),
};

export const Industries = () => {
  return (
    <section
      id="industries"
      data-testid="industries-section"
      className="scroll-mt-nav py-24 md:py-36 border-t border-ink/10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-12 gap-6 mb-14 md:mb-20">
          <div className="col-span-12 md:col-span-4">
            <div className="overline text-forest-accent mb-4">/ 03 — Industries</div>
            <h2
              className="font-display font-bold leading-[1.02] tracking-tight text-ink text-balance"
              style={{ fontSize: "clamp(2rem, 4.5vw, 3.5rem)" }}
            >
              Where our
              <br />
              chemistry travels.
            </h2>
          </div>
          <div className="col-span-12 md:col-span-7 md:col-start-6 md:pt-4">
            <p className="text-ink-soft text-base md:text-lg leading-relaxed max-w-xl">
              From a snack manufacturer in Hanoi to a feed mill in Rotterdam — Milestone
              antioxidants travel quietly through global supply chains, holding
              freshness in place.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-ink/10 border border-ink/10">
          {INDUSTRIES.map((ind, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <motion.div
                key={ind.name}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true, margin: "-60px" }}
                variants={fadeUp}
                custom={i}
                data-testid={`industry-${i}`}
                className="bg-bone p-8 md:p-10 group hover:bg-white transition-colors min-h-[220px] flex flex-col"
              >
                <div className="flex items-start justify-between mb-auto">
                  <Icon className="w-6 h-6 text-ink/70 group-hover:text-amber-accent transition-colors" strokeWidth={1.5} />
                  <span className="font-mono text-[11px] text-ink-soft">
                    0{i + 1}
                  </span>
                </div>
                <div className="mt-8">
                  <div className="font-display font-medium text-ink text-xl md:text-2xl leading-tight mb-2">
                    {ind.name}
                  </div>
                  <p className="text-ink-soft text-sm leading-relaxed">
                    {ind.desc}
                  </p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
